<form>
  <spk-card [class]="'col-md-8'" title="Search Examples">
    <spk-search-grid #grid defaultSortProperty="Id DESC" list="ExampleSearchRow" [leftLinks]="leftLinks" [headerLinks]="headerLinks" [rightLinks]="rightLinks"></spk-search-grid>
  </spk-card>
</form>